<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M26.667 48C14.885 48 5.333 38.449 5.333 26.667c0-11.782 9.552-21.334 21.334-21.334S48 14.885 48 26.667c0 4.93-1.672 9.469-4.48 13.081l13.67 13.67c1.041 1.042 1.041 2.73 0 3.772-1.042 1.041-2.73 1.041-3.772 0l-13.67-13.67C36.136 46.328 31.597 48 26.667 48zm0-5.333c8.836 0 16-7.164 16-16 0-8.837-7.164-16-16-16-8.837 0-16 7.163-16 16 0 8.836 7.163 16 16 16z" transform="translate(-1220 -750) translate(1220 750)"/>
            </g>
        </g>
    </g>
</svg>
